import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["onClick"];
import React, { memo, useRef } from 'react';
import { useOnScreenEffect } from '@beef/utils';
import { useAnalyticsLinks } from "../hooks/useAnalyticsLinks";
import { AnalyticsPusherFAQ } from "../utils/analytics";
export var withAnalyticsFAQ = function withAnalyticsFAQ(WrappedComponent) {
  return /*#__PURE__*/memo(function (_ref) {
    var _props$categories$;
    var onClick = _ref.onClick,
      props = _objectWithoutProperties(_ref, _excluded);
    var refTabId = useRef((_props$categories$ = props.categories[0]) === null || _props$categories$ === void 0 ? void 0 : _props$categories$.id);
    var refPanelId = useRef('');
    var ref = useOnScreenEffect(function () {
      AnalyticsPusherFAQ.pushViewEvent();
    }, []);
    useAnalyticsLinks(ref, props.blockIndex);
    var handleClick = function handleClick(val) {
      if (val.panelId) {
        refPanelId.current = val.panelId;
        var activeTabData = props.data.find(function (tab) {
          return tab.categoryId === refTabId.current;
        });
        var activePanelData = activeTabData.tabs.find(function (tab) {
          return tab.id === val.panelId;
        });
        AnalyticsPusherFAQ.pushClickEvent(activePanelData === null || activePanelData === void 0 ? void 0 : activePanelData.title);
      }
      if (val.tabId) {
        refTabId.current = val.tabId;
        var activeTab = props.categories.find(function (tab) {
          return tab.id === val.tabId;
        });
        AnalyticsPusherFAQ.pushClickEvent(activeTab === null || activeTab === void 0 ? void 0 : activeTab.title, true);
      }
      onClick === null || onClick === void 0 ? void 0 : onClick(val);
    };
    return /*#__PURE__*/React.createElement(WrappedComponent, _extends({
      ref: ref
    }, props, {
      onClick: handleClick,
      "data-t-id": "src-hocs"
    }));
  });
};